import { render, staticRenderFns } from "./TabTransferComponent.vue?vue&type=template&id=5991c4dc&scoped=true"
import script from "./TabTransferComponent.vue?vue&type=script&lang=js"
export * from "./TabTransferComponent.vue?vue&type=script&lang=js"
import style0 from "./TabTransferComponent.vue?vue&type=style&index=0&id=5991c4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5991c4dc",
  null
  
)

export default component.exports